import { render, staticRenderFns } from "./Rol.vue?vue&type=template&id=57333e37&"
import script from "./Rol.vue?vue&type=script&lang=js&"
export * from "./Rol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports